import Table from './table';
import TableColumn from './table-column';
Table.Column = TableColumn;
export default Table;